<template>
  <main :class="[
    'min-h-screen pt-20 pb-16 relative overflow-hidden ',
    `season-${season}`,
    showMapView ? 'map-view-active' : '',
    'mt-200' 
  ]" style="margin-top: 80px;">
    <!-- 背景装饰 - 传统中国图案 -->
    <div class="background-decorations">
      <!-- 云纹背景 -->
      <div class="cloud-pattern"></div>
      
      <!-- 山水背景 -->
      <div class="landscape-pattern"></div>
      
      <!-- 古驿道路径动画 -->
      <svg class="ancient-route" viewBox="0 0 1000 600" preserveAspectRatio="none">
        <path class="route-path" d="M100,300 C200,200 300,400 400,300 S600,100 700,300 S900,400 950,300" />
      </svg>
    </div>
    
    <!-- 节气指示器 -->
    <!-- <div class="solar-term-indicator">
      <div class="solar-term-icon"></div>
      <div class="solar-term-text">{{ currentSolarTerm }}</div>
    </div>
     -->
    <div class="container">
      <!-- 页面标题 - 中国传统风格 -->
      <div class="page-title">
        <!-- 印章效果 -->
        <div class="seal-effect"></div>
        
        <h1 class="main-title">
          <span>
            山西景点
            <!-- 毛笔效果下划线 -->
            <svg class="brush-stroke" viewBox="0 0 100 10" preserveAspectRatio="none">
              <path d="M0,5 C20,0 40,10 60,5 C80,0 100,10 100,5" />
            </svg>
          </span>
        </h1>
        
        <p class="subtitle">
          探索山西最具代表性的文化与自然景观，感受三晋大地的千年文明
        </p>
      </div>
      
      <!-- 视图切换 -->
      <div class="view-toggle">
        <button 
          @click="showMapView = false" 
          :class="['view-toggle-btn', !showMapView ? 'active' : '']"
        >
          <span>列表视图</span>
        </button>
        <button 
          @click="showMapView = true" 
          :class="['view-toggle-btn', showMapView ? 'active' : '']"
        >
          <span>地图视图</span>
        </button>
        <!-- 打开弹窗的按钮 -->
        <el-button @click="showPuzzleDialog = true" class="puzzle-game-btn">拼合古建</el-button>

      </div>
      
       <!-- 互动元素 - 文化小游戏入口 -->
    <div>
    
    <!-- 弹窗组件，包裹当前拼图组件 -->
    <el-dialog
      title="晋韵寻踪·古建拼合"
      v-model="showPuzzleDialog"
      @close="showPuzzleDialog = false"
      width="1200px"
    >
    <!-- 将当前组件作为弹窗的内容 -->
      <PuzzleGameComponent />
    </el-dialog>
   </div>

      <!-- 筛选器 - 卷轴风格 -->
      <div class="filter-scroll">
        <!-- 卷轴装饰 -->
        <div class="scroll-decoration left"></div>
        <div class="scroll-decoration right"></div>
        
        <!-- 文化日历提示 -->
        <div v-if="culturalEvent" class="cultural-event-alert">
          <div class="cultural-event-icon"></div>
          <p>{{ currentCulturalEvent.name }}将于{{ currentCulturalEvent.daysLeft }}天后开始，相关景点: {{ culturalEvent.location }}</p>
        </div>
        
        <div class="category-tags">
          <button 
            v-for="category in categories" 
            :key="category.value"
            @click="activeCategory = category.value"
            :class="['category-tag', activeCategory === category.value ? 'active' : '']"
          >
            <span class="tag-text">{{ category.label }}</span>
            <!-- 青铜器纹样装饰线 -->
            <div class="bronze-pattern-line"></div>
          </button>
        </div>
      </div>
      
      <!-- 地图视图 -->
      <div v-if="showMapView" class="shanxi-map-container">
        <div class="shanxi-map">
    
          <div class="map-svg" >
            <!-- 简化的山西省轮廓 -->
             <img src="/images/map/map01.jpg" alt="" style="width: 20rem;height: 31.25rem;">
            <path class="province-outline" />
            <div class="map-image"></div>
          </div>
          
          <!-- 地图侧边景点列表 -->
          <div class="map-sidebar">
            <h3 class="map-sidebar-title">{{ activeCity ? getCityName(activeCity) : '全省' }}景点</h3>
            <div class="map-attractions-list">
              <div 
                v-for="attraction in cityFilteredAttractions" 
                :key="attraction.id"
                class="map-attraction-item"
                @click="highlightAttraction(attraction.id)"
              >
                <div class="map-attraction-image">
                  <img :src="attraction.image" :alt="attraction.name" />
                </div>
                <div class="map-attraction-info">
                  <h4>{{ attraction.name }}</h4>
                  <p>{{ attraction.location }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 列表视图 - 时间轴和内容区 -->
      <div v-else class="content-layout">
        <!-- 时间轴 - 桌面端显示在左侧 - 卷轴风格 -->
        <div class="timeline-scroll">
          <!-- 卷轴顶部装饰 -->
          <div class="scroll-top-decoration"></div>
          
          <h2 class="timeline-title">
            山西历史长河
            <div class="decorative-line"></div>
          </h2>
          
          <div class="timeline-events">
            <div 
              v-for="(item, index) in timeline" 
              :key="index"
              class="timeline-event"
            >
              <!-- 时间点 - 中国结风格 -->
              <div class="time-point"></div>
              
              <!-- 内容 -->
              <div class="event-content">
                <p class="event-year">{{ item.year }}</p>
                <p class="event-description">{{ item.event }}</p>
                
                <!-- 相关景点 -->
                <div v-if="item.related && item.related.length > 0" class="related-attractions">
                  <span 
                    v-for="relatedId in item.related" 
                    :key="relatedId"
                    class="related-attraction"
                    @click="highlightAttraction(relatedId)"
                  >
                    {{ getAttractionName(relatedId) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 卷轴底部装饰 -->
          <div class="scroll-bottom-decoration"></div>
          
          <!-- 文人墨客题词 -->
          <div class="poet-quote" @click="playDialectAudio">
            <p class="quote-text">{{ currentPoetQuote.text }}</p>
            <p class="quote-author">—— {{ currentPoetQuote.author }}</p>
          </div>
        </div>

        <!-- 主内容区 -->
        <div class="main-content">
          <!-- 结果统计 - 中国风边框 -->
          <div class="results-stats">
            <p>
              显示 <span class="highlight-text">{{ filteredAttractions.length }}</span> 个景点
              <span v-if="activeCategory !== 'all'">
                (分类: <span class="highlight-text">{{ getCategoryLabel(activeCategory) }}</span>)
              </span>
            </p>
            
            <!-- 排序选项 -->
            <div class="sort-options">
              <span>排序:</span>
              <select class="sort-select" v-model="sortOption">
                <option value="default">默认排序</option>
                <option value="name">按名称</option>
                <option value="location">按地区</option>
              </select>
            </div>
          </div>
          
          <!-- 景点瀑布流 -->
          <div class="attractions-grid">
            <transition-group name="attraction-fade">
              <div 
                v-for="attraction in sortedAttractions" 
                :key="attraction.id"
                :data-attraction-id="attraction.id"
                :class="['attraction-card-container', {'highlighted': highlightedAttractionId === attraction.id}]"
                @mouseenter="startAttractionHoverTimer(attraction.id)"
                @mouseleave="clearAttractionHoverTimer"
              >
                <!-- 沉浸式卡片设计 -->
                <div class="attraction-card">
                  <!-- 图片层 -->
                  <div class="card-image-layer">
                    <img 
                      :src="attraction.image" 
                      :alt="attraction.name"
                      class="attraction-image"
                      @click="activateTimeComparisonMode(attraction.id)"
                    />
                    
                    <!-- 位置标签 -->
                    <div class="location-badge">
                      <svg class="location-icon" viewBox="0 0 24 24">
                        <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" />
                        <path d="M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z" />
                      </svg>
                      {{ attraction.location }}
                    </div>
                    
                    <!-- 节气标识 -->
                    <div class="seasonal-badge" :class="`season-${season}`">
                      {{ seasonNames[season] }}
                    </div>
                  </div>
                  
                  <!-- 古籍底纹层 -->
                  <div class="ancient-book-pattern"></div>
                  
                  <!-- 内容层 -->
                  <div class="card-content">
                    <h3 class="attraction-name">{{ attraction.name }}</h3>
                    
                    <!-- 标签 -->
                    <div class="tags-container">
                      <span 
                        v-for="(tag, index) in attraction.tags" 
                        :key="index" 
                        class="attraction-tag"
                        :class="`season-${season}`"
                      >
                        {{ tag }}
                      </span>
                    </div>
                    
                    <!-- 描述 -->
                    <p class="attraction-description">{{ attraction.description }}</p>
                    
                    <!-- 了解更多按钮 -->
                    <div class="more-info-button-container">
                      <button class="more-info-button" @click="highlightAttraction(attraction.id)">
                        <router-link :to="'scene/' + attraction.landscape" style="color: black; text-decoration: none;">了解更多</router-link>
 
                        <svg class="arrow-icon" viewBox="0 0 24 24">
                          <path d="M9 6L15 12L9 18" />
                        </svg>
                      </button>
                    </div>
                  </div>
          </div>
                
                <!-- 卡片装饰 - 中国风角花 -->
                <div class="corner-decoration top-left"></div>
                <div class="corner-decoration top-right"></div>
                <div class="corner-decoration bottom-left"></div>
                <div class="corner-decoration bottom-right"></div>
                
                <!-- 历史记忆浮层 -->
                <div v-if="showHistoryLayer === attraction.id" class="history-memory-layer">
                  <div class="memory-content">
                    <h4>历史记忆</h4>
                    <blockquote class="historical-quote">
                      {{ getHistoricalQuote(attraction.id) }}
                    </blockquote>
                    <div class="related-cultural-attractions">
                      <h5>同文化带景点</h5>
                      <div class="related-attractions-list">
                        <span 
                          v-for="relatedId in getRelatedAttractions(attraction.id)" 
                          :key="relatedId"
                          class="related-attraction-item"
                          @click="highlightAttraction(relatedId)"
                        >
                          {{ getAttractionName(relatedId) }}
                        </span>
                      </div>
                    </div>
                    <button class="close-memory" @click.stop="showHistoryLayer = null">关闭</button>
                  </div>
                </div>
              </div>
            </transition-group>
          </div>
          
          <!-- 无结果提示 - 中国风样式 -->
          <div v-if="filteredAttractions.length === 0" class="no-results">
            <div class="no-results-icon"></div>
            <h3 class="no-results-title">暂无符合条件的景点</h3>
            <p class="no-results-text">请尝试选择其他分类或重置筛选条件</p>
            <button class="reset-filter-button" @click="activeCategory = 'all'">
              查看全部景点
            </button>
          </div>
          
          <!-- 分页 - 中国风样式 -->
          <div v-if="filteredAttractions.length > 0" class="pagination">
            <div class="pagination-container">
              <!-- 上一页 -->
              <button 
                :class="['pagination-button', 'prev', {'disabled': currentPage <= 1}]"
                :disabled="currentPage <= 1"
                @click="currentPage > 1 && (currentPage--)"
              >
                <svg class="pagination-arrow" viewBox="0 0 24 24">
                  <path d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              
              <!-- 页码 -->
              <button 
                v-for="page in 5" 
                :key="page"
                :class="['pagination-button', 'page', {'active': currentPage === page}]"
                @click="currentPage = page"
              >
                {{ page }}
              </button>
              
              <!-- 下一页 -->
              <button 
                :class="['pagination-button', 'next', {'disabled': currentPage >= 5}]"
                :disabled="currentPage >= 5"
                @click="currentPage < 5 && (currentPage++)"
              >
                <svg class="pagination-arrow" viewBox="0 0 24 24">
                  <path d="M9 5l7 7-7 7" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
     
    <!-- 音频元素 -->
    <audio ref="dialectAudio" src="/assets/audio/dialect-sample.mp3"></audio>
    <audio ref="environmentAudio" src="/assets/audio/environment-sample.mp3"></audio>
  </main>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import PuzzleGameComponent from './GamePage.vue'
import { inject } from 'vue';

// 季节与节气
const season = ref('autumn')
const seasonNames = {
  spring: '春',
  summer: '夏',
  autumn: '秋',
  winter: '冬'
}
const currentSolarTerm = ref('清明')

// 视图控制
const showMapView = ref(false)
const activeCity = ref(null)
const activeCategory = ref('all')
const currentPage = ref(1)
const highlightedAttractionId = ref(null)
const showHistoryLayer = ref(null)
const timeComparisonMode = ref(null)
const timeSliderValue = ref(50)
const attractionHoverTimer = ref(null)
const sortOption = ref('default')

// 文化活动
const culturalEvent = [
  {
    name: '平遥古城灯会',
    daysLeft: 15,
    location: '平遥古城'
  },
  {
    name: '平遥古城国际摄影大展',
    daysLeft: 18,
    location: '平遥古城'
  },
  {
    name: '云冈石窟佛教艺术季',
    daysLeft: 32,
    location: '大同云冈石窟'
  },
  {
    name: '五台山禅修文化节',
    daysLeft: 5,
    location: '五台山菩萨顶'
  },
  {
    name: '晋商民俗文化周',
    daysLeft: 12,
    location: '晋中乔家大院'
  },
  {
    name: '壶口瀑布国际漂流赛',
    daysLeft: 25,
    location: '临汾吉县壶口瀑布'
  },
  {
    name: '应县木塔古建灯光秀',
    daysLeft: 8,
    location: '朔州应县木塔'
  },
  {
    name: '恒山悬空寺武术交流大会',
    daysLeft: 43,
    location: '浑源悬空寺'
  },
  {
    name: '太原双塔樱花文化节',
    daysLeft: 15,
    location: '太原永祚寺'
  },
  {
    name: '皇城相府明清服饰展演',
    daysLeft: 21,
    location: '晋城皇城相府'
  },
  {
    name: '汾酒文化博览会',
    daysLeft: 36,
    location: '吕梁汾阳杏花村'
  },
  {
    name: '鹳雀楼诗词朗诵会',
    daysLeft: 7,
    location: '永济鹳雀楼'
  },
  {
    name: '太行山国际红叶节',
    daysLeft: 55,
    location: '长治太行山大峡谷'
  }
]

const currentCulturalEvent = ref(culturalEvent[0]);
// 诗词引用
const poetQuotes = [
  { text: '太行山上一寺小，五台山下一僧家。', author: '李白' },
  { text: '晋祠流水如碧玉，晋阳泉香馥郁。', author: '王维' },
  { text: '平遥城郭雄且固，代北之屏障也。', author: '范仲淹' }
]
const currentPoetQuote = ref(poetQuotes[0])

// 分类数据
const categories = [
  { label: '全部景点', value: 'all' },
  { label: '文化古迹', value: 'cultural-heritage' },
  { label: '自然风光', value: 'nature' },
  { label: '非遗体验', value: 'intangible-heritage' },
  { label: '晋味美食', value: 'jin-cuisine' },
  { label: '佛教圣地', value: 'buddhist' },
  { label: '晋商文化', value: 'jin-merchant' }
]

// 城市数据
const cities = [
  { id: 1, name: '太原', x: 200, y: 250 },
  { id: 2, name: '大同', x: 180, y: 120 },
  { id: 3, name: '晋中', x: 220, y: 280 },
  { id: 4, name: '忻州', x: 150, y: 180 },
  { id: 5, name: '朔州', x: 120, y: 100 },
  { id: 6, name: '临汾', x: 210, y: 380 },
  { id: 7, name: '运城', x: 150, y: 420 }
]

// 历史时间轴数据
const timeline = [
  { year: "前1046年", event: "晋国建立", related: [5] },
  { year: "公元523年", event: "云冈石窟完工", related: [1] },
  { year: "公元782年", event: "应县木塔建成", related: [4] },
  { year: "公元1370年", event: "平遥古城墙建成", related: [2] },
  { year: "公元1644年", event: "晋商兴起", related: [6, 8] },
  { year: "公元1997年", event: "平遥古城列入世界遗产", related: [2] }
]

// 景点数据
const attractions = ref([
  {
    id: 1,
    name: "云冈石窟",
    landscape: "yungang",
    image: "images/yungang.png",
    tags: ["世界遗产", "佛教艺术"],
    categories: ["cultural-heritage", "buddhist"],
    description: "云冈石窟位于山西省大同市西郊，始建于北魏文成帝年间，是中国四大石窟之一，以宏伟的气势和精湛的艺术享誉世界。",
    location: "山西省大同市",
    cityId: 2,
    hasGame: true,
    historicalQuote: "云冈之雕凿，气势恢宏，佛像庄严，实为东方艺术之瑰宝。",
    relatedAttractions: [3, 4]
  },
  {
    id: 2,
    name: "平遥古城",
    landscape: "pingyao",
    image: "images/pingyao.png",
    tags: ["世界遗产", "古城"],
    categories: ["cultural-heritage", "jin-merchant"],
    description: "平遥古城是中国保存最为完整的四座古城之一，也是目前我国唯一以整座古城申报世界遗产获得成功的古县城。",
    location: "山西省晋中市",
    cityId: 3,
    hasGame: true,
    historicalQuote: "平遥城墙坚固如铁，街巷纵横有序，实为晋商文化之缩影。",
    relatedAttractions: [6, 8]
  },
  {
    id: 3,
    name: "五台山",
    landscape: "wutaishan",
    image: "images/五台山.png",
    tags: ["佛教圣地", "自然风光"],
    categories: ["buddhist", "nature"],
    description: "五台山是中国四大佛教名山之一，以文殊菩萨道场闻名于世，拥有众多历史悠久的寺庙和壮丽的自然风光。",
    location: "山西省忻州市",
    cityId: 4,
    hasGame: false,
    historicalQuote: "五台山者，文殊菩萨所居，佛法东来，此山为首。",
    relatedAttractions: [1, 9]
  },
  {
    id: 4,
    name: "应县木塔",
    landscape: "yingxian",
    image: "images/应县木塔.png",
    tags: ["古建筑", "文化遗产"],
    categories: ["cultural-heritage"],
    description: "应县木塔是中国现存最高最古老的木塔，建于辽代，是中国古代木结构建筑的杰出代表。",
    location: "山西省朔州市",
    cityId: 5,
    hasGame: true,
    historicalQuote: "应县木塔，九层飞檐，不用一钉，巧夺天工，千年不倒。",
    relatedAttractions: [1, 5]
  },
  {
    id: 5,
    name: "晋祠",
    landscape: "jinci",
    image: "images/晋祠.png",
    tags: ["古建筑", "园林"],
    categories: ["cultural-heritage"],
    description: "晋祠是中国现存最早的皇家园林，以其精美的建筑、雕刻和园林艺术著称。",
    location: "山西省太原市",
    cityId: 1,
    hasGame: false,
    historicalQuote: "晋祠圣母像，神态安详，技艺精湛，为中国古代彩塑艺术之巅峰。",
    relatedAttractions: [4, 9]
  },
  {
    id: 6,
    name: "乔家大院",
    landscape: "qiaojiadayuan",
    image: "images/乔家大院.png",
    tags: ["晋商文化", "民居"],
    categories: ["jin-merchant", "cultural-heritage"],
    description: "乔家大院是晋商文化的代表，展示了清代晋商的生活方式和建筑艺术。",
    location: "山西省祁县",
    cityId: 3,
    hasGame: false,
    historicalQuote: "乔家大院，砖雕木刻，精美绝伦，处处彰显晋商之富贵与审美。",
    relatedAttractions: [2, 8]
  },
  {
    id: 7,
    name: "恒山",
    landscape: "hengshan",
    image: "images/恒山.png",
    tags: ["自然风光", "道教名山"],
    categories: ["nature"],
    description: "恒山是中国五岳之一的北岳，以险峻著称，山上有悬空寺等著名景点。",
    location: "山西省大同市",
    cityId: 2,
    hasGame: false,
    historicalQuote: "恒山悬空寺，危峰兀立，匠心独运，令人叹为观止。",
    relatedAttractions: [3, 9]
  },
  {
    id: 8,
    name: "王家大院",
    landscape: "wangjiadayuan",
    image: "images/王家大院.png",
    tags: ["晋商文化", "民居"],
    categories: ["jin-merchant", "cultural-heritage"],
    description: "王家大院是清代晋商的代表性建筑，展示了晋商的辉煌与财富。",
    location: "山西省灵石县",
    cityId: 3,
    hasGame: false,
    historicalQuote: "王家大院规模宏大，结构严谨，体现了晋商'义利并举'的经营理念。",
    relatedAttractions: [2, 6]
  },
  {
    id: 9,
    name: "绵山",
    landscape: "mianshan",
    image: "images/绵山.png",
    tags: ["自然风光", "道教名山"],
    categories: ["nature"],
    description: "绵山是道教名山，以其壮丽的自然风光和悠久的历史文化著称。",
    location: "山西省介休市",
    cityId: 6,
    hasGame: false,
    historicalQuote: "绵山峰峦叠嶂，云雾缭绕，自古为道家修行之圣地。",
    relatedAttractions: [3, 7]
  }
])

// 根据分类筛选景点
const filteredAttractions = computed(() => {
  if (activeCategory.value === 'all') {
    return attractions.value
  }
  return attractions.value.filter(attraction => 
    attraction.categories.includes(activeCategory.value)
  )
})

// 根据城市筛选景点
const cityFilteredAttractions = computed(() => {
  if (!activeCity.value) {
    return attractions.value
  }
  return attractions.value.filter(attraction => attraction.cityId === activeCity.value)
})

// 排序景点
const sortedAttractions = computed(() => {
  const attractions = [...filteredAttractions.value]
  
  if (sortOption.value === 'name') {
    return attractions.sort((a, b) => a.name.localeCompare(b.name, 'zh-CN'))
  } else if (sortOption.value === 'location') {
    return attractions.sort((a, b) => a.location.localeCompare(b.location, 'zh-CN'))
  }
  
  return attractions
})

// 获取分类标签
const getCategoryLabel = (value) => {
  const category = categories.find(cat => cat.value === value)
  return category ? category.label : ''
}

// 获取城市名称
const getCityName = (id) => {
  const city = cities.find(city => city.id === id)
  return city ? city.name : ''
}

// 获取景点名称
const getAttractionName = (id) => {
  const attraction = attractions.value.find(attr => attr.id === id)
  return attraction ? attraction.name : ''
}

// 获取历史引用
const getHistoricalQuote = (id) => {
  const attraction = attractions.value.find(attr => attr.id === id)
  return attraction ? attraction.historicalQuote : ''
}

// 获取相关景点
const getRelatedAttractions = (id) => {
  const attraction = attractions.value.find(attr => attr.id === id)
  return attraction ? attraction.relatedAttractions : []
}

// 高亮显示景点
const highlightAttraction = (id) => {
  highlightedAttractionId.value = id
  
  // 如果景点不在当前分类中，切换到全部分类
  const attraction = attractions.value.find(attr => attr.id === id)
  if (attraction && activeCategory.value !== 'all' && !attraction.categories.includes(activeCategory.value)) {
    activeCategory.value = 'all'
  }
  
  // 滚动到景点位置
  setTimeout(() => {
    const element = document.querySelector(`[data-attraction-id="${id}"]`)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
    
    // 3秒后取消高亮
    setTimeout(() => {
      highlightedAttractionId.value = null
    }, 3000)
  }, 100)
}

// 选择城市
// const selectCity = (cityId) => {
//   activeCity.value = cityId === activeCity.value ? null : cityId
// }

// 开始景点悬停计时器
const startAttractionHoverTimer = (id) => {
  clearAttractionHoverTimer()
  attractionHoverTimer.value = setTimeout(() => {
    showHistoryLayer.value = id
  }, 1000) // 1秒后显示历史记忆浮层
}

// 清除景点悬停计时器
const clearAttractionHoverTimer = () => {
  if (attractionHoverTimer.value) {
    clearTimeout(attractionHoverTimer.value)
    attractionHoverTimer.value = null
  }
}

// 激活时空对比模式
const activateTimeComparisonMode = (id) => {
  timeComparisonMode.value = id
  timeSliderValue.value = 50
}

const showPuzzleDialog = ref(false); // 控制弹窗显示的响应式变量

// 播放方言音频
const playDialectAudio = () => {
  const audio = document.querySelector('audio[ref="dialectAudio"]')
  if (audio) {
    audio.play()
  }
}

// 监听分类变化，重置页码
watch(activeCategory, () => {
  currentPage.value = 1
})

// 季节变化监听
const currentSeason = inject('currentSeason');
watch(currentSeason, () => {
  season.value = currentSeason.value
  currentSolarTerm.value = currentSeason.value === 'spring' ? '春分' : '夏至'
  // 根据季节变化背景样式
  document.body.className = `season-${season.value}`
  document.querySelector('.background-decorations').className = `background-decorations season-${season.value}`
});

// 组件挂载后
onMounted(() => {
  // 随机切换诗词引用
  setInterval(() => {
    const randomIndex = Math.floor(Math.random() * poetQuotes.length)
    currentPoetQuote.value = poetQuotes[randomIndex]
    const randomIndex1 = Math.floor(Math.random() * culturalEvent.length)
    currentCulturalEvent.value = culturalEvent[randomIndex1];
  }, 3000) // 每3秒切换一次
  
})
</script>

<style scoped>
/* 基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  max-width: 1350px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 10;
}

/* 季节背景 */
.season-spring {
  background-image: linear-gradient(to bottom, rgba(230, 244, 234, 0.3), rgba(139, 69, 19, 0.1));
}

.season-summer {
  background-image: linear-gradient(to bottom, rgba(225, 245, 254, 0.3), rgba(139, 69, 19, 0.1));
}

.season-autumn {
  background-image: linear-gradient(to bottom, rgba(255, 243, 224, 0.3), rgba(139, 69, 19, 0.1));
}

.season-winter {
  background-image: linear-gradient(to bottom, rgba(245, 245, 245, 0.3), rgba(224, 224, 224, 0.1));
}

/* 背景装饰 */
.background-decorations {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  opacity: 0.05;
}

.cloud-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 200px;
  background-image: url('https://via.placeholder.com/800x200/eee/aaa');
  background-size: contain;
  background-repeat: repeat-x;
  animation: float 60s infinite ease-in-out;
}

.landscape-pattern {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 200px;
  background-image: url('https://via.placeholder.com/800x200/eee/aaa');
  background-size: contain;
  background-repeat: repeat-x;
}

.ancient-route {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s ease;
}

.map-view-active .ancient-route {
  opacity: 0.3;
}

.route-path {
  fill: none;
  stroke: #8B4513;
  stroke-width: 2;
  stroke-dasharray: 10;
  stroke-dashoffset: 1000;
  animation: dash 30s linear infinite;
}

/* 节气指示器 */
.solar-term-indicator {
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(139, 69, 19, 0.3);
  border-radius: 20px;
  padding: 5px 10px;
  z-index: 100;
}

.solar-term-icon {
  width: 24px;
  height: 24px;
  background-image: url('https://via.placeholder.com/800x200/eee/aaa');
  background-size: contain;
  margin-right: 5px;
}

.solar-term-text {
  font-size: 14px;
  color: #8B4513;
  font-weight: 500;
}

/* 页面标题 */
.page-title {
  text-align: center;
  margin-bottom: 4rem;
  position: relative;
  /* background-image: url('C:\Users\22935\Desktop\项目\NewDemoView\app\public\images\homeshow\春天景色小.png');
  background-size: cover; */
}

.seal-effect {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 128px;
  height: 128px;
  border-radius: 50%;
  border: 8px solid rgba(195, 39, 43, 0.2);
  z-index: -1;
}

.main-title {
  font-size: clamp(2rem, 5vw, 3rem);
  color: #8B4513;
  margin-bottom: 1.5rem;
  font-family: 'Noto Serif SC', serif;
  position: relative;
  display: inline-block;
}

.main-title span {
  position: relative;
}

.brush-stroke {
  position: absolute;
  bottom: -16px;
  left: 0;
  width: 100%;
  height: 12px;
}

.brush-stroke path {
  stroke: #C3272B;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
}

.subtitle {
  color: rgba(139, 69, 19, 0.7);
  max-width: 600px;
  margin: 0 auto;
  font-size: 1.125rem;
  line-height: 1.6;
}

/* 视图切换 */
.view-toggle {
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
  gap: 1rem;
}

.view-toggle-btn {
  padding: 0.5rem 1.5rem;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(139, 69, 19, 0.3);
  border-radius: 0.5rem;
  color: #8B4513;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.view-toggle-btn::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: #C3272B;
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.view-toggle-btn.active {
  background: rgba(139, 69, 19, 0.1);
  border-color: #8B4513;
}

.view-toggle-btn.active::after {
  transform: scaleX(1);
}

.view-toggle-btn:hover {
  background: rgba(139, 69, 19, 0.05);
}

/* 筛选器卷轴 */
.filter-scroll {
  margin-bottom: 3rem;
  padding: 1.5rem;
  position: relative;
  background: rgba(245, 222, 179, 0.2);
  border-radius: 0.5rem;
}

.scroll-decoration {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 16px;
}

.scroll-decoration.left {
  left: 0;
  background-image: linear-gradient(to right, rgba(139, 69, 19, 0.2), transparent);
}

.scroll-decoration.right {
  right: 0;
  background-image: linear-gradient(to left, rgba(139, 69, 19, 0.2), transparent);
}

.cultural-event-alert {
  margin-bottom: 1rem;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.8);
  border: 1px dashed rgba(195, 39, 43, 0.3);
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
}

.cultural-event-icon {
  width: 24px;
  height: 24px;
  background-image: url('https://via.placeholder.com/800x200/eee/aaa');
  background-size: contain;
  margin-right: 10px;
}

.category-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: center;
}

.category-tag {
  padding: 0.625rem 1.25rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(139, 69, 19, 0.3);
  background: rgba(255, 255, 255, 0.8);
  color: #8B4513;
  cursor: pointer;
}

.category-tag.active {
  background: #8B4513;
  color: white;
  border-color: #8B4513;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.category-tag:hover:not(.active) {
  border-color: #8B4513;
  background: rgba(245, 222, 179, 0.3);
}

.bronze-pattern-line {
  position: absolute;
  bottom: -2px;
  left: 25%;
  right: 25%;
  height: 3px;
  background-image: url('https://via.placeholder.com/800x200/eee/aaa');
  background-size: contain;
  opacity: 0;
  transform: scaleX(0);
  transition: all 0.3s ease;
}

.category-tag.active .bronze-pattern-line {
  opacity: 1;
  transform: scaleX(1);
}

/* 山西地图 */
.shanxi-map-container {
  margin-bottom: 3rem;
}

.shanxi-map {
  display: flex;
  gap: 2rem;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 0.5rem;
  padding: 1.5rem;
  border: 1px solid rgba(139, 69, 19, 0.2);
}

.map-svg {
  flex: 1;
  max-width: 400px;
  height: auto;
}

.province-outline {
  fill: rgba(245, 222, 179, 0.3);
  stroke: #8B4513;
  stroke-width: 2;
}

.city-marker {
  fill: #C3272B;
  stroke: white;
  stroke-width: 1;
  cursor: pointer;
  transition: all 0.3s ease;
}

.city-marker.active {
  fill: #3B5A9D;
}

.city-name {
  font-size: 12px;
  fill: #8B4513;
  font-family: 'Noto Serif SC', serif;
}

.map-images{
  background-image: url('');
  background-size: cover;
  background-position: center;
}
.merchant-route {
  fill: none;
  stroke: rgba(139, 69, 19, 0.5);
  stroke-width: 2;
  stroke-dasharray: 5;
  stroke-dashoffset: 0;
  animation: dash 20s linear infinite;
}

.map-sidebar {
  flex: 1;
  max-height: 500px;
  overflow-y: auto;
}

.map-sidebar-title {
  font-size: 1.25rem;
  color: #8B4513;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(139, 69, 19, 0.2);
  font-family: 'Noto Serif SC', serif;
}

.map-attractions-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.map-attraction-item {
  display: flex;
  gap: 1rem;
  padding: 0.75rem;
  border-radius: 0.5rem;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(139, 69, 19, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
}

.map-attraction-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(139, 69, 19, 0.1);
}

.map-attraction-image {
  width: 80px;
  height: 60px;
  overflow: hidden;
  border-radius: 0.25rem;
}

.map-attraction-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.map-attraction-info {
  flex: 1;
}

.map-attraction-info h4 {
  font-size: 1rem;
  color: #8B4513;
  margin-bottom: 0.25rem;
  font-family: 'Noto Serif SC', serif;
}

.map-attraction-info p {
  font-size: 0.75rem;
  color: rgba(139, 69, 19, 0.7);
}

/* 内容布局 */
.content-layout {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

@media (min-width: 1024px) {
  .content-layout {
    flex-direction: row;
  }
}

/* 时间轴卷轴 */
.timeline-scroll {
  position: sticky;
  top: 6rem;
  align-self: flex-start;
  background: rgba(245, 222, 179, 0.3);
  backdrop-filter: blur(4px);
  border-radius: 0.5rem;
  padding: 1.5rem;
  border: 1px solid rgba(139, 69, 19, 0.2);
  width: 100%;
}

@media (min-width: 1024px) {
  .timeline-scroll {
    width: 25%;
  }
}

.scroll-top-decoration {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 64px;
  height: 24px;
  background: rgba(139, 69, 19, 0.2);
  border-top-left-radius: 50%;
  border-top-right-radius: 50%;
}

.scroll-bottom-decoration {
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 64px;
  height: 24px;
  background: rgba(245, 222, 179, 0.3);
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;
}

.timeline-title {
  font-size: 1.25rem;
  color: #8B4513;
  margin-bottom: 1.5rem;
  text-align: center;
  position: relative;
  font-family: 'Noto Serif SC', serif;
}

.decorative-line {
  position: absolute;
  bottom: -8px;
  left: 0;
  right: 0;
  height: 2px;
  background: rgba(139, 69, 19, 0.3);
}

.timeline-events {
  position: relative;
  border-left: 2px solid rgba(139, 69, 19, 0.5);
  padding-left: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.timeline-event {
  position: relative;
}

.time-point {
  position: absolute;
  left: -29px;
  top: 6px;
  width: 16px;
  height: 16px;
  background: #C3272B;
  border: 2px solid #F5DEB3;
  border-radius: 2px;
  transform: rotate(45deg);
  transition: transform 0.3s ease;
}

.timeline-event:hover .time-point {
  transform: rotate(0);
}

.event-content {
  transform: translateX(0);
  transition: transform 0.3s ease;
}

.timeline-event:hover .event-content {
  transform: translateX(4px);
}

.event-year {
  font-size: 0.875rem;
  color: #3B5A9D;
  font-weight: 500;
  margin-bottom: 0.25rem;
  font-family: 'Noto Serif SC', serif;
}

.event-description {
  color: #8B4513;
}

.related-attractions {
  margin-top: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
}

.related-attraction {
  font-size: 0.75rem;
  padding: 0.125rem 0.5rem;
  background: rgba(245, 222, 179, 0.5);
  color: #8B4513;
  border-radius: 0.25rem;
  cursor: pointer;
  border: 1px solid rgba(139, 69, 19, 0.2);
  transition: all 0.2s ease;
}

.related-attraction:hover {
  background: rgba(245, 222, 179, 0.8);
}

.poet-quote {
  margin-top: 2rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 0.5rem;
  border: 1px dashed rgba(139, 69, 19, 0.3);
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
}

.poet-quote:hover {
  background: rgba(255, 255, 255, 0.8);
}

.poet-quote::before {
  content: '"';
  position: absolute;
  top: 0;
  left: 0.5rem;
  font-size: 3rem;
  line-height: 1;
  color: rgba(139, 69, 19, 0.2);
  font-family: serif;
}

.quote-text {
  font-style: italic;
  color: #8B4513;
  margin-bottom: 0.5rem;
  font-family: 'Noto Serif SC', serif;
}

.quote-author {
  text-align: right;
  color: rgba(139, 69, 19, 0.7);
  font-size: 0.875rem;
}

/* 主内容区 */
.main-content {
  flex: 1;
}

.results-stats {
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid rgba(139, 69, 19, 0.3);
  color: rgba(139, 69, 19, 0.7);
  font-size: 0.875rem;
}

.highlight-text {
  font-weight: 500;
  color: #8B4513;
}

.sort-options {
  display: flex;
  align-items: center;
}

.sort-options span {
  margin-right: 0.5rem;
}

.sort-select {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(139, 69, 19, 0.2);
  border-radius: 0.375rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  color: #8B4513;
  outline: none;
}

.sort-select:focus {
  outline: none;
  range: 1px solid #8B4513;
}

/* 景点网格 */
.attractions-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1.5rem;
  margin-bottom: 3rem;
}

@media (min-width: 768px) {
  .attractions-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .attractions-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.attraction-card-container {
  position: relative;
  transition: all 0.3s ease;
}

.attraction-card-container.highlighted {
  grid: 4px solid rgba(195, 39, 43, 0.5);
  outline-offset: 2px;
}

/* 沉浸式卡片设计 */
.attraction-card {
  position: relative;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(139, 69, 19, 0.2);
  transition: all 0.3s ease;
  transform: translateY(0);
}

.attraction-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}

.card-image-layer {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.attraction-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.7s ease;
}

.attraction-card:hover .attraction-image {
  transform: scale(1.1);
}

.time-comparison-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.time-slider-container {
  width: 80%;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 0.5rem;
}

.time-slider {
  width: 100%;
  margin-bottom: 0.5rem;
}

.time-labels {
  display: flex;
  justify-content: space-between;
  font-size: 0.75rem;
  color: #8B4513;
}

.close-comparison {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.8);
  border: none;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
}

.location-badge {
  position: absolute;
  bottom: 0.75rem;
  left: 0.75rem;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  color: #8B4513;
  border: 1px solid rgba(139, 69, 19, 0.2);
}

.location-icon {
  width: 12px;
  height: 12px;
  margin-right: 0.25rem;
  stroke: currentColor;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.seasonal-badge {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  font-weight: 500;
}

.seasonal-badge.season-spring {
  background: rgba(56, 142, 60, 0.2);
  color: #388E3C;
  border: 1px solid rgba(56, 142, 60, 0.3);
}

.seasonal-badge.season-summer {
  background: rgba(2, 136, 209, 0.2);
  color: #0288D1;
  border: 1px solid rgba(2, 136, 209, 0.3);
}

.seasonal-badge.season-autumn {
  background: rgba(245, 124, 0, 0.2);
  color: #F57C00;
  border: 1px solid rgba(245, 124, 0, 0.3);
}

.seasonal-badge.season-winter {
  background: rgba(84, 110, 122, 0.2);
  color: #546E7A;
  border: 1px solid rgba(84, 110, 122, 0.3);
}

.ancient-book-pattern {
  position: absolute;
  inset: 0;
  background-image: url('https://dummyimage.com/800x200/ccc/000');
  background-size: 200px;
  opacity: 0.05;
  mix-blend-mode: multiply;
  pointer-events: none;
}

.card-content {
  position: relative;
  padding: 1rem;
  background: linear-gradient(to bottom, white, rgba(255, 255, 255, 0.9));
}

.attraction-name {
  font-size: 1.125rem;
  font-weight: 500;
  color: #8B4513;
  margin-bottom: 0.5rem;
  font-family: 'Noto Serif SC', serif;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 0.75rem;
}

.attraction-tag {
  font-size: 0.75rem;
  padding: 0.125rem 0.5rem;
  border-radius: 9999px;
  border: 1px solid;
}

.attraction-tag.season-spring {
  background: #E6F4EA;
  color: #388E3C;
  border-color: rgba(56, 142, 60, 0.2);
}

.attraction-tag.season-summer {
  background: #E1F5FE;
  color: #0288D1;
  border-color: rgba(2, 136, 209, 0.2);
}

.attraction-tag.season-autumn {
  background: #FFF3E0;
  color: #F57C00;
  border-color: rgba(245, 124, 0, 0.2);
}

.attraction-tag.season-winter {
  background: #F5F5F5;
  color: #546E7A;
  border-color: rgba(84, 110, 122, 0.2);
}

.attraction-description {
  font-size: 0.875rem;
  color: rgba(139, 69, 19, 0.8);
  margin-bottom: 1rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.cultural-data-visualization {
  margin-bottom: 1rem;
}

.timeline-visualization {
  height: 2px;
  background: rgba(139, 69, 19, 0.1);
  position: relative;
  margin: 1rem 0;
}

.timeline-point {
  position: absolute;
  transform: translateX(-50%);
}

.point-marker {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3B5A9D;
  position: absolute;
  top: -3px;
  left: 50%;
  transform: translateX(-50%);
}

.point-label {
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.625rem;
  color: #8B4513;
  white-space: nowrap;
}

.more-info-button-container {
  text-align: right;
}

.more-info-button {
  font-size: 0.875rem;
  color: #8B4513;
  background: none;
  border: none;
  padding: 0;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  transition: color 0.2s ease;
}

.more-info-button:hover {
  color: #C3272B;
}

.arrow-icon {
  width: 16px;
  height: 16px;
  margin-left: 0.25rem;
  stroke: currentColor;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.mini-game-entry {
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  color: #8B4513;
  border: 1px solid rgba(139, 69, 19, 0.2);
  cursor: pointer;
  transition: all 0.2s ease;
}

.mini-game-entry:hover {
  background: rgba(255, 255, 255, 0.9);
  transform: translateY(-2px);
}

.game-icon {
  width: 16px;
  height: 16px;
  background-image: url('https://dummyimage.com/800x200/ccc/000');
  background-size: contain;
  margin-right: 0.25rem;
}

/* 卡片角花装饰 */
.corner-decoration {
  position: absolute;
  width: 24px;
  height: 24px;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.attraction-card-container:hover .corner-decoration {
  opacity: 1;
}

.corner-decoration.top-left {
  top: 0;
  left: 0;
  border-top: 2px solid rgba(139, 69, 19, 0.3);
  border-left: 2px solid rgba(139, 69, 19, 0.3);
}

.corner-decoration.top-right {
  top: 0;
  right: 0;
  border-top: 2px solid rgba(139, 69, 19, 0.3);
  border-right: 2px solid rgba(139, 69, 19, 0.3);
}

.corner-decoration.bottom-left {
  bottom: 0;
  left: 0;
  border-bottom: 2px solid rgba(139, 69, 19, 0.3);
  border-left: 2px solid rgba(139, 69, 19, 0.3);
}

.corner-decoration.bottom-right {
  bottom: 0;
  right: 0;
  border-bottom: 2px solid rgba(139, 69, 19, 0.3);
  border-right: 2px solid rgba(139, 69, 19, 0.3);
}

/* 历史记忆浮层 */
.history-memory-layer {
  position: absolute;
  top: 0;
  right: -300px;
  width: 280px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0.5rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(139, 69, 19, 0.2);
  padding: 1rem;
  z-index: 20;
  animation: slideIn 0.5s forwards;
}

@keyframes slideIn {
  to {
    right: -290px;
  }
}

.memory-content h4 {
  font-size: 1rem;
  color: #8B4513;
  margin-bottom: 0.75rem;
  font-family: 'Noto Serif SC', serif;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(139, 69, 19, 0.2);
}

.historical-quote {
  font-style: italic;
  color: #8B4513;
  margin-bottom: 1rem;
  padding: 0.75rem;
  background: rgba(245, 222, 179, 0.2);
  border-radius: 0.25rem;
  border-left: 3px solid #C3272B;
  font-size: 0.875rem;
  font-family: 'Noto Serif SC', serif;
}

.related-cultural-attractions h5 {
  font-size: 0.875rem;
  color: #8B4513;
  margin-bottom: 0.5rem;
  font-family: 'Noto Serif SC', serif;
}

.related-attractions-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.related-attraction-item {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  background: rgba(245, 222, 179, 0.3);
  color: #8B4513;
  border-radius: 0.25rem;
  cursor: pointer;
  border: 1px solid rgba(139, 69, 19, 0.2);
  transition: all 0.2s ease;
}

.related-attraction-item:hover {
  background: rgba(245, 222, 179, 0.5);
}

.close-memory {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  background: rgba(139, 69, 19, 0.1);
  color: #8B4513;
  border: 1px solid rgba(139, 69, 19, 0.2);
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.close-memory:hover {
  background: rgba(139, 69, 19, 0.2);
}

/* 无结果提示 */
.no-results {
  padding: 4rem 0;
  text-align: center;
  border: 1px dashed rgba(139, 69, 19, 0.3);
  border-radius: 0.5rem;
  background: rgba(245, 222, 179, 0.1);
}

.no-results-icon {
  width: 96px;
  height: 96px;
  margin: 0 auto 1rem;
  opacity: 0.3;
  background-image: url('https://dummyimage.com/800x200/ccc/000');
  background-size: contain;
}

.no-results-title {
  font-size: 1.25rem;
  color: #8B4513;
  margin-bottom: 0.5rem;
  font-family: 'Noto Serif SC', serif;
}

.no-results-text {
  color: rgba(139, 69, 19, 0.7);
  margin-bottom: 1rem;
}

.reset-filter-button {
  padding: 0.5rem 1.5rem;
  background: #8B4513;
  color: white;
  border-radius: 0.375rem;
  border: 1px solid rgba(139, 69, 19, 0.5);
  cursor: pointer;
  transition: all 0.2s ease;
}

.reset-filter-button:hover {
  background: rgba(139, 69, 19, 0.9);
}

/* 分页 */
.pagination {
  margin-top: 3rem;
  display: flex;
  justify-content: center;
}

.pagination-container {
  display: inline-flex;
  border: 1px solid rgba(139, 69, 19, 0.3);
  border-radius: 0.5rem;
  overflow: hidden;
}

.pagination-button {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border-right: 1px solid rgba(139, 69, 19, 0.3);
}

.pagination-button:last-child {
  border-right: none;
}

.pagination-button.page {
  background: white;
  color: #8B4513;
}

.pagination-button.page:hover:not(.active) {
  background: rgba(245, 222, 179, 0.3);
}

.pagination-button.page.active {
  background: #8B4513;
  color: white;
}

.pagination-button.prev,
.pagination-button.next {
  background: white;
  color: #8B4513;
}

.pagination-button.prev:hover:not(.disabled),
.pagination-button.next:hover:not(.disabled) {
  background: rgba(245, 222, 179, 0.3);
}

.pagination-button.disabled {
  background: rgba(255, 255, 255, 0.5);
  color: rgba(139, 69, 19, 0.3);
  cursor: not-allowed;
}

.pagination-arrow {
  width: 20px;
  height: 20px;
  stroke: currentColor;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* 小游戏 */
.puzzle-game-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.5rem;
  font-size: 1.125rem;
  font-weight: 500;
  color: white;
  background: #C3272B; /* 中国红 */
  border: 2px solid #8B4513; /* 深棕边框 */
  border-radius: 30px;
  box-shadow: 0 4px 12px rgba(195, 39, 43, 0.2);
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
}

.puzzle-game {
  display: flex;
  padding: 1rem;
  gap: 1rem;
}

.puzzle-pieces {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  width: 50%;
}

.puzzle-piece {
  aspect-ratio: 1;
  background-image: url('https://dummyimage.com/800x200/ccc/000');
  background-size: 300px 300px;
  border: 1px solid rgba(139, 69, 19, 0.3);
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.puzzle-piece:hover:not(.placed) {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.puzzle-piece.placed {
  opacity: 0.5;
  cursor: not-allowed;
}

.puzzle-board {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  width: 50%;
  background: rgba(245, 222, 179, 0.2);
  padding: 0.5rem;
  border-radius: 0.25rem;
}

.puzzle-cell {
  aspect-ratio: 1;
  background: rgba(255, 255, 255, 0.8);
  border: 1px dashed rgba(139, 69, 19, 0.3);
  border-radius: 0.25rem;
}

.puzzle-cell.filled {
  background-image: url('https://dummyimage.com/800x200/ccc/000');
  background-size: 300px 300px;
  border: 1px solid rgba(139, 69, 19, 0.5);
}

.game-progress {
  height: 4px;
  background: rgba(139, 69, 19, 0.1);
  margin: 0 1rem 1rem;
}

.progress-bar {
  height: 100%;
  background: #C3272B;
  transition: width 0.3s ease;
}

.game-message {
  text-align: center;
  padding: 1rem;
  color: #8B4513;
  font-weight: 500;
  background: rgba(245, 222, 179, 0.3);
}

/* 动画 */
@keyframes float {
  0% { transform: translateY(0) translateX(0); }
  25% { transform: translateY(-20px) translateX(10px); }
  50% { transform: translateY(0) translateX(20px); }
  75% { transform: translateY(20px) translateX(10px); }
  100% { transform: translateY(0) translateX(0); }
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}

/* 景点卡片淡入淡出动画 */
.attraction-fade-enter-active,
.attraction-fade-leave-active {
  transition: all 0.5s ease;
}

.attraction-fade-enter-from,
.attraction-fade-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .page-title {
    margin-bottom: 2rem;
  }
  
  .filter-scroll {
    margin-bottom: 2rem;
  }
  
  .timeline-scroll {
    position: static;
    margin-bottom: 2rem;
  }
  
  .puzzle-game {
    flex-direction: column;
  }
  
  .puzzle-pieces,
  .puzzle-board {
    width: 100%;
  }
}
</style>